import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  TextField,
  CardHeader,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NorthWestIcon from "@mui/icons-material/NorthWest";
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ContactForm = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
  };

  return (
    <>
      <div id="contact-section">
        <Box
          sx={{
            minHeight: "80vh",
            width: "100vw",
            maxWidth: "1900px",
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            mt: 2,
          }}
        >
          <Grid
            container
            spacing={4}
            sx={{
              maxWidth: 1200,
              mx: "auto",
            }}
          >
            {/* Left Section */}
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              sx={{
                color: "white",
                textAlign: { xs: "center", md: "left" },
                maxWidth: { xs: "470px", sm: "550px", md: "600px" },
              }}
            >
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{
                  fontSize: {
                    xs: "1.5rem",
                    sm: "2rem",
                    md: "2rem",
                  },
                  textAlign: "center",
                }}
              >
                <Typography component="span" sx={{ color: "#0F758E", marginLeft: "-42px", }}>
                  Global Procurement Excellence
                </Typography>
                <br />
                {/* <span style={{ marginLeft: "-20px", fontSize: '1}>
                  Global Procurement Excellence
                </span> */}
              </Typography>
              <Typography sx={{ mr: 8 }}>
                These cases are perfectly simple and easy to distinguish. In a free
                hour, when our power of <br /> choice is untrammelled.
              </Typography>
              <Box sx={{ mt: 2, mr: 8 }}>
                {["Sales and business development initiatives", "Commercial contract negotiation and strategy", "OEM and supplier relationship management", "Market intelligence and opportunity identification ", "Pricing and margin optimization"].map(
                  (text, index) => (
                    <Box
                      key={index}
                      display="flex"
                      alignItems="center"

                      mb={2}
                      justifyContent={{ xs: "center", md: "flex-start" }}
                    >
                      <CheckCircleIcon sx={{ color: "#0F758E", mr: 1 }} />

                      <Typography variant="body1">{text}</Typography>
                    </Box>
                  )
                )}
              </Box>

              <Box
                sx={{
                  // mt: 4,
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  gap: { xs: 2, md: 0 },
                  color: "white",

                  textAlign: { xs: "center", md: "left" },
                }}
              >
                {[
                  {
                    title: "Canada",
                    address:
                      "Address: Unit: C, 2155 Lawrence Ave E, Scarborough, ON M1R 5G9",
                    email: "Email:quazi@trilliumsourcing.com",
                    phone: "Mobile: +16475457225",
                  },

                ].map((info, index) => (
                  <Box
                    sx={{
                      border: "1px solid white",
                      // backgroundColor: 'white',
                      // color: "#0F758E",
                      backgroundColor: "#0F758E",
                      px: 1,
                      py: 1,
                      mr: 8,
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#0F758E",
                        color: "white",
                        border: "1px solid white",
                      },
                    }}
                    key={index}
                  >
                    <Typography variant="h6" fontWeight="bold">
                      <LocationOnIcon sx={{ fontSize: 20 }} />
                      {info.title}
                    </Typography>
                    <Typography variant="body1">
                      {info.address}
                      <br />
                      {info.email}
                      <br />
                      {info.phone}
                    </Typography>
                  </Box>
                ))}
              </Box>
              {/* <Box
                display="flex"
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    px: 4,
                    py: 1.5,
                    mr: 8,
                    backgroundColor: "#0F758E",
                    color: "white",
                    // backgroundColor: "white",
                    // color: "#0F758E",
                    border: "2px solid #0F758E",
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                    "&:hover": {
                      backgroundColor: "white",
                      color: "#0F758E",
                      border: "1px solid #0F758E",
                    },
                  }}
                >
                  request for quotation
                  <NorthWestIcon />
                </Button>
              </Box> */}
            </Grid>

            {/* Right Section */}
            <Grid item xs={12} md={6}>
              <Card
                elevation={3}
                sx={{
                  p: { xs: 2, md: 4 },
                  borderTop: "4px solid #0F758E",
                  maxWidth: { xs: "100%", md: 500 },
                  mx: "auto",
                }}
              >
                <CardHeader
                  title="Feel Free to Contact Us"
                  titleTypographyProps={{
                    fontSize: { xs: "1.25rem", md: "1.5rem" },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                />
                <CardContent>
                  <Box
                    component="form"
                    onSubmit={handleSubmit}
                    noValidate
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <TextField label="Name" variant="outlined" fullWidth required />
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Phone"
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Email"
                          variant="outlined"
                          fullWidth
                          required
                          type="email"
                        />
                      </Grid>
                    </Grid>
                    <TextField label="Subject" variant="outlined" fullWidth />
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                    />
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={{ xs: "center", md: "center" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        mt: 2,
                        px: 2,
                        mx: "auto",
                        // display: "block",
                        backgroundColor: "#0F758E",
                        color: "white",

                        fontSize: { xs: "0.875rem", sm: "1rem" },
                        "&:hover": {
                          backgroundColor: "white",
                          color: "#0F758E",
                          border: "1px solid #0F758E",
                        },
                      }}
                    >
                      Send Message
                      <NorthWestIcon />
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default ContactForm;
